import { render, staticRenderFns } from "./bindHigh.vue?vue&type=template&id=542997c6&scoped=true&"
import script from "./bindHigh.vue?vue&type=script&lang=js&"
export * from "./bindHigh.vue?vue&type=script&lang=js&"
import style0 from "./bindHigh.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bindHigh.vue?vue&type=style&index=1&id=542997c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542997c6",
  null
  
)

export default component.exports